import { Stack } from "@mui/material";
import * as React from "react";
import { ErrorBoundary } from "../../../components/ErrorBoundary";
import { AircraftLastUpdated } from "./AircraftLastUpdated";
import { FlightBridgeStatus } from "./FlightBridgeStatus";
import { RenderJobHistory } from "./RenderJobHistory/RenderJobHistory";
import { WorkerStatus } from "./WorkerStatus";

export const UberAdmin: React.FC<{}> = () => {
  return (
    <Stack direction="column" spacing={4} maxWidth={1000}>
      <WorkerStatus />
      <FlightBridgeStatus />
      <ErrorBoundary
        fallbackTitle="Job History Error"
        fallbackDescription="Unable to load render job history. Please refresh the page."
      >
        <RenderJobHistory />
      </ErrorBoundary>
      <AircraftLastUpdated />
    </Stack>
  );
};
